<template>
  <input
    :id="id"
    v-model="modelValue"
    type="date"
    :name="id"
    class="form-input block min-w-0 flex-1 rounded-r-none border-r-0 border-solid border-border placeholder:text-muted-foreground first:rounded-l-md focus:z-20 focus:border-blue-600 focus:ring-blue-600 sm:text-sm"
    :placeholder="placeholder"
  />
</template>

<script lang="ts" setup>
defineProps<{
  id: string;
  placeholder?: string;
}>();

const modelValue = defineModel<string>("modelValue");
</script>
